/**
 *
 * @param {string} name
 * @returns
 */

const url = `app`;

export const LOAD_ACTIVITIES_LIST = `${url}/LOAD_ACTIVITIES_LIST`;
export const LOAD_ACTIVITIES_LIST_SUCCESS = `${url}/LOAD_ACTIVITIES_LIST_SUCCESS`;
export const LOAD_ACTIVITIES_LIST_ERROR = `${url}/LOAD_ACTIVITIES_LIST_ERROR`;
export const LOAD_CAB_DETAILS = `${url}/LOAD_CAB_DETAILS`;
export const LOAD_CAB_DETAILS_SUCCESS = `${url}/LOAD_CAB_DETAILS_SUCCESS`;
export const LOAD_CAB_DETAILS_ERROR = `${url}/LOAD_CAB_DETAILS_ERROR`;
export const LOAD_STATE_ACTIVITIES_LIST = `${url}/LOAD_STATE_ACTIVITIES_LIST`;
export const LOAD_STATE_ACTIVITIES_LIST_SUCCESS = `${url}/LOAD_STATE_ACTIVITIES_LIST_SUCCESS`;
export const LOAD_STATE_ACTIVITIES_LIST_ERROR = `${url}/LOAD_STATE_ACTIVITIES_LIST_ERROR`;
export const LOAD_CITY_ACTIVITIES_LIST = `${url}/LOAD_CITY_ACTIVITIES_LIST`;
export const LOAD_CITY_ACTIVITIES_LIST_SUCCESS = `${url}/LOAD_CITY_ACTIVITIES_LIST_SUCCESS`;
export const LOAD_CITY_ACTIVITIES_LIST_ERROR = `${url}/LOAD_CITY_ACTIVITIES_LIST_ERROR`;
export const LOAD_AREA_ACTIVITIES_LIST = `${url}/LOAD_AREA_ACTIVITIES_LIST`;
export const LOAD_AREA_ACTIVITIES_LIST_SUCCESS = `${url}/LOAD_AREA_ACTIVITIES_LIST_SUCCESS`;
export const LOAD_AREA_ACTIVITIES_LIST_ERROR = `${url}/LOAD_AREA_ACTIVITIES_LIST_ERROR`;
export const LOAD_SIMILAR_AREA_ACTIVITIES_LIST = `${url}/LOAD_SIMILAR_AREA_ACTIVITIES_LIST`;
export const LOAD_SIMILAR_AREA_ACTIVITIES_LIST_SUCCESS = `${url}/LOAD_SIMILAR_AREA_ACTIVITIES_LIST_SUCCESS`;
export const LOAD_SIMILAR_AREA_ACTIVITIES_LIST_ERROR = `${url}/LOAD_SIMILAR_AREA_ACTIVITIES_LIST_ERROR`;

export const LOAD_ACTIVITIES_REVIEWS_LIST = `${url}/LOAD_ACTIVITIES_REVIEWS_LIST`;
export const LOAD_ACTIVITIES_REVIEWS_LIST_SUCCESS = `${url}/LOAD_ACTIVITIES_REVIEWS_LIST_SUCCESS`;
export const LOAD_ACTIVITIES_REVIEWS_LIST_ERROR = `${url}/LOAD_ACTIVITIES_REVIEWS_LIST_ERROR`;

export const LOAD_SINGLE_ACTIVITIES_REVIEWS_LIST = `${url}/LOAD_SINGLE_ACTIVITIES_REVIEWS_LIST`;
export const LOAD_SINGLE_ACTIVITIES_REVIEWS_LIST_SUCCESS = `${url}/LOAD_SINGLE_ACTIVITIES_REVIEWS_LIST_SUCCESS`;
export const LOAD_SINGLE_ACTIVITIES_REVIEWS_LIST_ERROR = `${url}/LOAD_SINGLE_ACTIVITIES_REVIEWS_LIST_ERROR`;

export const LOAD_ACTIVITIES_LIST_RECORDS_META_DATA = `${url}/LOAD_ACTIVITIES_LIST_RECORDS_META_DATA`;
export const LOAD_ACTIVITIES_LIST_RECORDS_META_DATA_SUCCESS = `${url}/LOAD_ACTIVITIES_LIST_RECORDS_META_DATA_SUCCESS`;
export const LOAD_ACTIVITIES_LIST_RECORDS_META_DATA_ERROR = `${url}/LOAD_ACTIVITIES_LIST_RECORDS_META_DATA_ERROR`;
export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`;

const constants = {
  LOAD_ACTIVITIES_LIST,
  LOAD_ACTIVITIES_LIST_SUCCESS,
  LOAD_ACTIVITIES_LIST_ERROR,
  LOAD_CAB_DETAILS,
  LOAD_CAB_DETAILS_SUCCESS,
  LOAD_CAB_DETAILS_ERROR,
  LOAD_STATE_ACTIVITIES_LIST,
  LOAD_STATE_ACTIVITIES_LIST_SUCCESS,
  LOAD_STATE_ACTIVITIES_LIST_ERROR,
  LOAD_CITY_ACTIVITIES_LIST,
  LOAD_CITY_ACTIVITIES_LIST_SUCCESS,
  LOAD_CITY_ACTIVITIES_LIST_ERROR,
  LOAD_SIMILAR_AREA_ACTIVITIES_LIST,
  LOAD_SIMILAR_AREA_ACTIVITIES_LIST_ERROR,
  LOAD_SIMILAR_AREA_ACTIVITIES_LIST_SUCCESS,
  LOAD_AREA_ACTIVITIES_LIST,
  LOAD_AREA_ACTIVITIES_LIST_SUCCESS,
  LOAD_AREA_ACTIVITIES_LIST_ERROR,
  LOAD_ACTIVITIES_REVIEWS_LIST,
  LOAD_ACTIVITIES_REVIEWS_LIST_SUCCESS,
  LOAD_ACTIVITIES_REVIEWS_LIST_ERROR,
  LOAD_SINGLE_ACTIVITIES_REVIEWS_LIST,
  LOAD_SINGLE_ACTIVITIES_REVIEWS_LIST_SUCCESS,
  LOAD_SINGLE_ACTIVITIES_REVIEWS_LIST_ERROR,

  LOAD_ACTIVITIES_LIST_RECORDS_META_DATA,
  LOAD_ACTIVITIES_LIST_RECORDS_META_DATA_SUCCESS,
  LOAD_ACTIVITIES_LIST_RECORDS_META_DATA_ERROR,
};

export default constants;
